import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toast-notification';

export const useDefaultToast = () => {
	const { t } = useI18n();
	const toaster = useToast();

	const toastSuccess = (message?: string) => {
		toaster.open({
			message: message ?? t('toast.defaultSuccess'),
			type: 'success',
			duration: 3000,
		});
	};

	const toastError = (message?: string) => {
		toaster.open({
			message: message ?? t('toast.defaultError'),
			type: 'error',
			duration: 3000,
		});
	};

	return {
		toastSuccess,
		toastError,
	};
};
